import React from 'react'

const DocumentUploadErrorRetry = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M12.5401 3.59766C7.98014 3.59766 4.32014 7.31766 4.32014 11.8777H2.52014L4.86014 15.9577L7.20014 11.8777H5.52014C5.52014 7.97766 8.70014 4.79766 12.6001 4.79766C16.5001 4.79766 19.6801 7.97766 19.6801 11.8777C19.6801 15.1177 17.4601 17.8177 14.5201 18.6577V19.8577C18.1801 19.0177 20.8801 15.7177 20.8801 11.8177C20.8801 7.31766 17.1001 3.59766 12.5401 3.59766Z"
            fill="#BF152C"
        />
    </svg>
)

export default DocumentUploadErrorRetry
